import styled from "styled-components";
import AntTimeline from "antd/es/timeline";

const Timeline = styled(AntTimeline)`
  .ant-timeline-item-head {
    background-color: ${(p) => p.theme.colors.cardBgColor};
    border-width: 2px;
  }
  .ant-timeline-item-tail {
    border-color: ${(p) => p.theme.colors.lightestBorderGrey};
  }
`;

Timeline.Item = AntTimeline.Item;

export default Timeline;
